import { axiosi } from "../../config/axios";
import { collection, query, where, doc , getDocs, getDoc , updateDoc ,  orderBy, limit, startAfter , serverTimestamp , addDoc } from "firebase/firestore";
import { db } from "../../firebase";

// export const addProduct=async(data)=>{
//     try {
//         const res=await axiosi.post('/products',data)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }


export const addProduct = async (product) => {
    try {
        const payload = {
            title: product.title,
            description: product.description,
            price: product.price,
            discountPercentage: product.discountPercentage ?? 0,
            category: product.category,      // categoryId string
            brand: product.brand,            // brandId string
            stockQuantity: product.stockQuantity ?? 0,
            thumbnail: product.thumbnail,
            images: product.images || [],
            slug: product.title.toLowerCase().replace(/ /g, "-"),
            isDeleted:false,
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp(),
        };

        const docRef = await addDoc(collection(db, "products"), payload);

        return {
            message: "Product added successfully",
            _id: docRef.id,
            ...payload,
        };

    } catch (error) {
        console.error("Error adding product:", error);
        throw { message: "Failed to add product", error };
    }
};

// export const fetchProducts=async(filters)=>{

//     let queryString=''

//     if(filters.brand){
//         filters.brand.map((brand)=>{
//             queryString+=`brand=${brand}&`
//         })
//     }
//     if(filters.category){
//         filters.category.map((category)=>{
//             queryString+=`category=${category}&`
//         })
//     }

//     if(filters.pagination){
//         queryString+=`page=${filters.pagination.page}&limit=${filters.pagination.limit}&`
//     }

//     if(filters.sort){
//         queryString+=`sort=${filters.sort.sort}&order=${filters.sort.order}&`
//     }

//     if(filters.user){
//         queryString+=`user=${filters.user}&`
//     }
    
//     try {
//         const res=await axiosi.get(`/productss?${queryString}`)
//         const totalResults=await res.headers.get("X-Total-Count")
//         return {data:res.data,totalResults:totalResults}
//     } catch (error) {
//         // throw error.response.data
//         return {
//             data: [
//             {
//                 "_id": "65a7e45902e12c44f599444e",
//                 "title": "iPhone 9",
//                 "description": "An apple mobile which is nothing like apple",
//                 "price": 549,
//                 "discountPercentage": 12.96,
//                 "category": "65a7e24602e12c44f599442c",
//                 "brand": {
//                     "_id": "65a7e20102e12c44f59943da",
//                     "name": "Apple",
//                     "__v": 0
//                 },
//                 "stockQuantity": 14,
//                 "thumbnail": "https://cdn.dummyjson.com/product-images/1/thumbnail.jpg",
//                 "images": [
//                     "https://cdn.dummyjson.com/product-images/1/1.jpg",
//                     "https://cdn.dummyjson.com/product-images/1/2.jpg",
//                     "https://cdn.dummyjson.com/product-images/1/3.jpg",
//                     "https://cdn.dummyjson.com/product-images/1/4.jpg",
//                     "https://cdn.dummyjson.com/product-images/1/thumbnail.jpg"
//                 ],
//                 "isDeleted": false,
//                 "updatedAt": "2024-02-07T09:22:57.840Z",
//                 "createdAt": "2025-11-29T16:22:52.593Z"
//             },
//             {
//                 "_id": "65a7e45902e12c44f599444f",
//                 "title": "Fog Scent Xpressio Perfume custom",
//                 "description": "Product details of Best Fog Scent Xpressio Perfume 100ml For Men cool long lasting perfumes for Men",
//                 "price": 13,
//                 "discountPercentage": 8.14,
//                 "category": "65a7e24602e12c44f599442e",
//                 "brand": {
//                     "_id": "65a7e20102e12c44f59943e3",
//                     "name": "Fog Scent Xpressio",
//                     "__v": 0
//                 },
//                 "stockQuantity": 21,
//                 "thumbnail": "https://cdn.dummyjson.com/product-images/13/thumbnail.webp",
//                 "images": [
//                     "https://cdn.dummyjson.com/product-images/13/1.jpg",
//                     "https://cdn.dummyjson.com/product-images/13/2.png",
//                     "https://cdn.dummyjson.com/product-images/13/3.jpg",
//                     "https://cdn.dummyjson.com/product-images/13/4.jpg"
//                 ],
//                 "isDeleted": false,
//                 "updatedAt": "2024-02-07T09:22:57.840Z",
//                 "createdAt": "2025-11-29T16:22:52.594Z"
//             },
//             {
//                 "_id": "65a7e45902e12c44f5994450",
//                 "title": "Samsung Universe 9",
//                 "description": "Samsung's new variant which goes beyond Galaxy to the Universe",
//                 "price": 1249,
//                 "discountPercentage": 15.46,
//                 "category": "65a7e24602e12c44f599442c",
//                 "brand": {
//                     "_id": "65a7e20102e12c44f59943db",
//                     "name": "Samsung",
//                     "__v": 0
//                 },
//                 "stockQuantity": 36,
//                 "thumbnail": "https://cdn.dummyjson.com/product-images/3/thumbnail.jpg",
//                 "images": [
//                     "https://cdn.dummyjson.com/product-images/3/1.jpg"
//                 ],
//                 "isDeleted": false,
//                 "updatedAt": "2024-02-07T09:22:57.840Z",
//                 "createdAt": "2025-11-29T16:22:52.594Z"
//             },
//             {
//                 "_id": "65a7e45902e12c44f5994451",
//                 "title": "OPPOF19",
//                 "description": "OPPO F19 is officially announced on April 2021.",
//                 "price": 280,
//                 "discountPercentage": 17.91,
//                 "category": "65a7e24602e12c44f599442c",
//                 "brand": {
//                     "_id": "65a7e20102e12c44f59943dc",
//                     "name": "OPPO",
//                     "__v": 0
//                 },
//                 "stockQuantity": 123,
//                 "thumbnail": "https://cdn.dummyjson.com/product-images/4/thumbnail.jpg",
//                 "images": [
//                     "https://cdn.dummyjson.com/product-images/4/1.jpg",
//                     "https://cdn.dummyjson.com/product-images/4/2.jpg",
//                     "https://cdn.dummyjson.com/product-images/4/3.jpg",
//                     "https://cdn.dummyjson.com/product-images/4/4.jpg",
//                     "https://cdn.dummyjson.com/product-images/4/thumbnail.jpg"
//                 ],
//                 "isDeleted": false,
//                 "updatedAt": "2024-02-07T09:22:57.840Z",
//                 "createdAt": "2025-11-29T16:22:52.594Z"
//             },
//             {
//                 "_id": "65a7e45902e12c44f5994452",
//                 "title": "Huawei P30",
//                 "description": "Huawei’s re-badged P30 Pro New Edition was officially unveiled yesterday in Germany and now the device has made its way to the UK.",
//                 "price": 499,
//                 "discountPercentage": 10.58,
//                 "category": "65a7e24602e12c44f599442c",
//                 "brand": {
//                     "_id": "65a7e20102e12c44f59943dd",
//                     "name": "Huawei",
//                     "__v": 0
//                 },
//                 "stockQuantity": 32,
//                 "thumbnail": "https://cdn.dummyjson.com/product-images/5/thumbnail.jpg",
//                 "images": [
//                     "https://cdn.dummyjson.com/product-images/5/1.jpg",
//                     "https://cdn.dummyjson.com/product-images/5/2.jpg",
//                     "https://cdn.dummyjson.com/product-images/5/3.jpg"
//                 ],
//                 "isDeleted": false,
//                 "updatedAt": "2024-02-07T09:22:57.840Z",
//                 "createdAt": "2025-11-29T16:22:52.594Z"
//             },
//             {
//                 "_id": "65a7e45902e12c44f5994453",
//                 "title": "MacBook Pro",
//                 "description": "MacBook Pro 2021 with mini-LED display may launch between September, November",
//                 "price": 1749,
//                 "discountPercentage": 11.02,
//                 "category": "65a7e24602e12c44f599442d",
//                 "brand": {
//                     "_id": "65a7e20102e12c44f59943da",
//                     "name": "Apple",
//                     "__v": 0
//                 },
//                 "stockQuantity": 83,
//                 "thumbnail": "https://cdn.dummyjson.com/product-images/6/thumbnail.png",
//                 "images": [
//                     "https://cdn.dummyjson.com/product-images/6/1.png",
//                     "https://cdn.dummyjson.com/product-images/6/2.jpg",
//                     "https://cdn.dummyjson.com/product-images/6/3.png",
//                     "https://cdn.dummyjson.com/product-images/6/4.jpg"
//                 ],
//                 "isDeleted": false,
//                 "updatedAt": "2024-02-07T09:22:57.840Z",
//                 "createdAt": "2025-11-29T16:22:52.594Z"
//             },
//             {
//                 "_id": "65a7e45902e12c44f5994454",
//                 "title": "Samsung Galaxy Book",
//                 "description": "Samsung Galaxy Book S (2020) Laptop With Intel Lakefield Chip, 8GB of RAM Launched",
//                 "price": 1499,
//                 "discountPercentage": 4.15,
//                 "category": "65a7e24602e12c44f599442d",
//                 "brand": {
//                     "_id": "65a7e20102e12c44f59943db",
//                     "name": "Samsung",
//                     "__v": 0
//                 },
//                 "stockQuantity": 50,
//                 "thumbnail": "https://cdn.dummyjson.com/product-images/7/thumbnail.jpg",
//                 "images": [
//                     "https://cdn.dummyjson.com/product-images/7/1.jpg",
//                     "https://cdn.dummyjson.com/product-images/7/2.jpg",
//                     "https://cdn.dummyjson.com/product-images/7/3.jpg",
//                     "https://cdn.dummyjson.com/product-images/7/thumbnail.jpg"
//                 ],
//                 "isDeleted": false,
//                 "updatedAt": "2024-02-07T09:22:57.840Z",
//                 "createdAt": "2025-11-29T16:22:52.594Z"
//             },
//             {
//                 "_id": "65a7e45902e12c44f5994455",
//                 "title": "Microsoft Surface Laptop 4",
//                 "description": "Style and speed. Stand out on HD video calls backed by Studio Mics. Capture ideas on the vibrant touchscreen.",
//                 "price": 1499,
//                 "discountPercentage": 10.23,
//                 "category": "65a7e24602e12c44f599442d",
//                 "brand": {
//                     "_id": "65a7e20102e12c44f59943de",
//                     "name": "Microsoft Surface",
//                     "__v": 0
//                 },
//                 "stockQuantity": 68,
//                 "thumbnail": "https://cdn.dummyjson.com/product-images/8/thumbnail.jpg",
//                 "images": [
//                     "https://cdn.dummyjson.com/product-images/8/1.jpg",
//                     "https://cdn.dummyjson.com/product-images/8/2.jpg",
//                     "https://cdn.dummyjson.com/product-images/8/3.jpg",
//                     "https://cdn.dummyjson.com/product-images/8/4.jpg",
//                     "https://cdn.dummyjson.com/product-images/8/thumbnail.jpg"
//                 ],
//                 "isDeleted": false,
//                 "updatedAt": "2024-02-07T09:22:57.840Z",
//                 "createdAt": "2025-11-29T16:22:52.594Z"
//             },
//             {
//                 "_id": "65a7e45902e12c44f5994456",
//                 "title": "Infinix INBOOK",
//                 "description": "Infinix Inbook X1 Ci3 10th 8GB 256GB 14 Win10 Grey – 1 Year Warranty",
//                 "price": 1099,
//                 "discountPercentage": 11.83,
//                 "category": "65a7e24602e12c44f599442d",
//                 "brand": {
//                     "_id": "65a7e20102e12c44f59943df",
//                     "name": "Infinix",
//                     "__v": 0
//                 },
//                 "stockQuantity": 96,
//                 "thumbnail": "https://cdn.dummyjson.com/product-images/9/thumbnail.jpg",
//                 "images": [
//                     "https://cdn.dummyjson.com/product-images/9/1.jpg",
//                     "https://cdn.dummyjson.com/product-images/9/2.png",
//                     "https://cdn.dummyjson.com/product-images/9/3.png",
//                     "https://cdn.dummyjson.com/product-images/9/4.jpg",
//                     "https://cdn.dummyjson.com/product-images/9/thumbnail.jpg"
//                 ],
//                 "isDeleted": false,
//                 "updatedAt": "2024-02-07T09:22:57.840Z",
//                 "createdAt": "2025-11-29T16:22:52.595Z"
//             },
//             {
//                 "_id": "65a7e45902e12c44f5994457",
//                 "title": "HP Pavilion 15-DK1056WM",
//                 "description": "HP Pavilion 15-DK1056WM Gaming Laptop 10th Gen Core i5, 8GB, 256GB SSD, GTX 1650 4GB, Windows 10",
//                 "price": 1099,
//                 "discountPercentage": 6.18,
//                 "category": "65a7e24602e12c44f599442d",
//                 "brand": {
//                     "_id": "65a7e20102e12c44f59943e0",
//                     "name": "HP Pavilion",
//                     "__v": 0
//                 },
//                 "stockQuantity": 89,
//                 "thumbnail": "https://cdn.dummyjson.com/product-images/10/thumbnail.jpeg",
//                 "images": [
//                     "https://cdn.dummyjson.com/product-images/10/1.jpg",
//                     "https://cdn.dummyjson.com/product-images/10/2.jpg",
//                     "https://cdn.dummyjson.com/product-images/10/3.jpg",
//                     "https://cdn.dummyjson.com/product-images/10/thumbnail.jpeg"
//                 ],
//                 "isDeleted": false,
//                 "updatedAt": "2024-02-07T09:22:57.840Z",
//                 "createdAt": "2025-11-29T16:22:52.595Z"
//             }
//         ],
//         totalResults:100
    
//     }
//     }
// }

export const fetchProducts = async (filters) => {
    try {
        let q = collection(db, "products");
        let conditions = [];
        console.log('ff',filters);

        // if(filters.user){
        //     console.log('isDeleted');
        //     conditions.push(where("isDeleted", "!=", true));
        // }

        // BRAND FILTER
        if (filters.brand && filters.brand.length > 0) {
            conditions.push(where("brand", "in", filters.brand));
            
        }
        console.log('fetch sort product', conditions);
        // CATEGORY FILTER
        if (filters.category && filters.category.length > 0) {
            conditions.push(where("category", "in", filters.category));
        }
        
        
        // SORTING
        if (filters.sort) {
            conditions.push(orderBy(filters.sort.sort, filters.sort.order === "asc" ? "asc" : "desc"));
        }
        console.log('fetch sort product', conditions);
        // PAGINATION
        const limitValue = filters.pagination?.limit || 10;
        const pageNumber = filters.pagination?.page || 1;

        // Apply all conditions
        q = query(q, ...conditions);

        // Get all results (needed for total count)
        const snapAll = await getDocs(q);
        const totalResults = snapAll.size;

        // Pagination logic
        let itemsToSkip = (pageNumber - 1) * limitValue;

        let lastVisible = null;
        let paginatedQuery = q;

        if (itemsToSkip > 0) {
            let skipSnap = await getDocs(query(q, limit(itemsToSkip)));
            lastVisible = skipSnap.docs[skipSnap.docs.length - 1];

            paginatedQuery = query(q, startAfter(lastVisible), limit(limitValue));
        } else {
            paginatedQuery = query(q, limit(limitValue));
        }
        // console.log('ff', paginatedQuery)
        // NOW GET PAGINATED DOCS
        const snap = await getDocs(paginatedQuery);
        let products;
        if (filters.user) {
             products = snap.docs
                .filter(doc => doc.data().isDeleted === false)
                .map((doc) => ({
                    _id: doc.id,
                    ...doc.data(),
                }));
        } else {
             products = snap.docs.map((doc) => ({
                _id: doc.id,
                ...doc.data(),
            }));
        }


        return {
            data: products,
            totalResults: products.length,
            // totalResults: totalResults,
        };

    } catch (error) {
        console.error(error);

        // fallback (same as your code)
        return {
            data: [ /* SAME DUMMY DATA YOU POSTED ABOVE */],
            totalResults: 100,
        };
    }
};



// export const fetchProductById = async (id) => {
//     try {

//         console.log('ff',id)
//         const ref = doc(db, "products", id);
//         const snap = await getDoc(ref);

//         if (!snap.exists()) {
//             throw new Error("Product not found");
//         }

//         return {
//             _id: snap.id,
//             ...snap.data(),
//         };

//     } catch (error) {
//         console.error("fetchProductById Error:", error);

//         // fallback dummy product
//         return {
//             "_id": "65a7e45902e12c44f599444e",
//             "title": "iPhone 9",
//             "description": "An apple mobile which is nothing like apple",
//             "price": 549,
//             "discountPercentage": 12.96,
//             "category": {
//                 "_id": "65a7e24602e12c44f599442c",
//                 "name": "smartphones",
//                 "__v": 0
//             },
//             "brand": {
//                 "_id": "65a7e20102e12c44f59943da",
//                 "name": "Apple",
//                 "__v": 0
//             },
//             "stockQuantity": 14,
//             "thumbnail": "https://cdn.dummyjson.com/product-images/1/thumbnail.jpg",
//             "images": [
//                 "https://cdn.dummyjson.com/product-images/1/1.jpg",
//                 "https://cdn.dummyjson.com/product-images/1/2.jpg",
//                 "https://cdn.dummyjson.com/product-images/1/3.jpg",
//                 "https://cdn.dummyjson.com/product-images/1/4.jpg",
//                 "https://cdn.dummyjson.com/product-images/1/thumbnail.jpg"
//             ],
//             "isDeleted": false,
//             "updatedAt": "2024-02-07T09:22:57.840Z",
//             "createdAt": "2025-11-29T16:22:52.593Z"
//         };
//     }
// };


export const fetchProductById = async (id) => {
    try {
        if (!id) throw new Error("Product ID missing");

        // Fetch product
        const productRef = doc(db, "products", id);
        const productSnap = await getDoc(productRef);

        if (!productSnap.exists()) {
            throw new Error("Product not found");
        }

        const product = {
            _id: productSnap.id,
            ...productSnap.data(),
        };

        // ---------------------------
        // 🔥 Populate Brand
        // ---------------------------
        if (product.brand) {
            const brandRef = doc(db, "brands", product.brand);
            const brandSnap = await getDoc(brandRef);

            if (brandSnap.exists()) {
                product.brand = {
                    _id: brandSnap.id,
                    ...brandSnap.data(),
                };
            }
        }

        // ---------------------------
        // 🔥 Populate Category
        // ---------------------------
        if (product.category) {
            const catRef = doc(db, "categories", product.category);
            const catSnap = await getDoc(catRef);

            if (catSnap.exists()) {
                product.category = {
                    _id: catSnap.id,
                    ...catSnap.data(),
                };
            }
        }

        return product;

    } catch (error) {
        console.error("fetchProductById Error:", error);

        // fallback
        return {
            "_id": "65a7e45902e12c44f599444e",
            "title": "iPhone 9",
            "description": "An apple mobile which is nothing like apple",
            "price": 549,
            "discountPercentage": 12.96,
            "category": {
                "_id": "65a7e24602e12c44f599442c",
                "name": "smartphones",
                "__v": 0
            },
            "brand": {
                "_id": "65a7e20102e12c44f59943da",
                "name": "Apple",
                "__v": 0
            },
            "stockQuantity": 14,
            "thumbnail": "https://cdn.dummyjson.com/product-images/1/thumbnail.jpg",
            "images": [
                "https://cdn.dummyjson.com/product-images/1/1.jpg",
                "https://cdn.dummyjson.com/product-images/1/2.jpg",
                "https://cdn.dummyjson.com/product-images/1/3.jpg",
                "https://cdn.dummyjson.com/product-images/1/4.jpg",
                "https://cdn.dummyjson.com/product-images/1/thumbnail.jpg"
            ],
            "isDeleted": false,
            "updatedAt": "2024-02-07T09:22:57.840Z",
            "createdAt": "2025-11-29T16:22:52.593Z"
        };
    }
};



// export const fetchProductById=async(id)=>{
//     try {
//         const res=await axiosi.get(`/productss/${id}`)
//         // return res.data
//     } catch (error) {
//         // throw error.response.data
//         return {
//             "_id": "65a7e45902e12c44f599444e",
//             "title": "iPhone 9",
//             "description": "An apple mobile which is nothing like apple",
//             "price": 549,
//             "discountPercentage": 12.96,
//             "category": {
//                 "_id": "65a7e24602e12c44f599442c",
//                 "name": "smartphones",
//                 "__v": 0
//             },
//             "brand": {
//                 "_id": "65a7e20102e12c44f59943da",
//                 "name": "Apple",
//                 "__v": 0
//             },
//             "stockQuantity": 14,
//             "thumbnail": "https://cdn.dummyjson.com/product-images/1/thumbnail.jpg",
//             "images": [
//                 "https://cdn.dummyjson.com/product-images/1/1.jpg",
//                 "https://cdn.dummyjson.com/product-images/1/2.jpg",
//                 "https://cdn.dummyjson.com/product-images/1/3.jpg",
//                 "https://cdn.dummyjson.com/product-images/1/4.jpg",
//                 "https://cdn.dummyjson.com/product-images/1/thumbnail.jpg"
//             ],
//             "isDeleted": false,
//             "updatedAt": "2024-02-07T09:22:57.840Z",
//             "createdAt": "2025-11-29T16:22:52.593Z"
//         };
//     }
// }

export const updateProductById = async (update) => {
    try {
        if (!update?._id) throw new Error("Product ID missing");

        const ref = doc(db, "products", update._id);

        // Remove _id before updating — Firestore doc ke andar nahi chahiye
        const { _id, ...payload } = update;

        await updateDoc(ref, payload);

        return {
            _id,
            ...payload,
        };

    } catch (error) {
        console.error("updateProductById Error:", error);
        
        throw {
            message: error.message || "Failed to update product",
        };
    }
};


// export const updateProductById=async(update)=>{
//     try {
//         const res=await axiosi.patch(`/products/${update._id}`,update)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }


export const undeleteProductById = async (id) => {
    try {
        if (!id) throw new Error("Product ID missing");

        const ref = doc(db, "products", id);

        // 1. Fetch current product
        const snap = await getDoc(ref);

        if (!snap.exists()) {
            throw new Error("Product not found");
        }

        const current = snap.data();

        // 2. Toggle isDeleted (true -> false, false -> true)
        const newValue = !current.isDeleted;

        // 3. Update product
        await updateDoc(ref, {
            isDeleted: newValue,
            updatedAt: new Date()
        });

        // 4. Return updated product
        return {
            message: `Product restored successfully`,
            _id: id,
            ...current,
            isDeleted: newValue
        };

    } catch (error) {
        console.error("undeleteProductById Error:", error);
        throw {
            message: error.message || "Failed to toggle product delete status",
        };
    }
};

// export const undeleteProductById=async(id)=>{
//     try {
//         const res=await axiosi.patch(`/products/undelete/${id}`)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }



export const deleteProductById = async (id) => {
    try {
        if (!id) throw new Error("Product ID missing");

        const ref = doc(db, "products", id);

        // 1. Fetch current product
        const snap = await getDoc(ref);

        if (!snap.exists()) {
            throw new Error("Product not found");
        }

        const current = snap.data();

        // 2. Toggle isDeleted (true -> false, false -> true)
        const newValue = !current.isDeleted;

        // 3. Update product
        await updateDoc(ref, {
            isDeleted: newValue,
            updatedAt: new Date()
        });

        // 4. Return updated product
        return {
            message: `Product restored successfully`,
            _id: id,
            ...current,
            isDeleted: newValue
        };

    } catch (error) {
        console.error("deleteProductById Error:", error);
        throw {
            message: error.message || "Failed to delete product",
        };
    }
};

// export const deleteProductById=async(id)=>{
//     try {
//         const res=await axiosi.delete(`/products/${id}`)
//         return res.data
//     } catch (error) {
//         throw error.response.data
//     }
// }
